import React from 'react';

function TemplateRoom({ title, disabled, onClick }) {
    return (<div className="app-template-room-container">
        <div className={`app-template-room${disabled ? " app-template-room-disabled" : ""}`} onClick={onClick}>{title}</div>
    </div>);
}

export default TemplateRoom;


// WEBPACK FOOTER //
// ./src/components/TemplateRoom.jsx